<template>
  <div class="spo-card rounded bordered p-2 my-3">
    <div class="text-h6 font-weight-bold">Créer un lien</div>
    <p>Cette fonction vous permet d'envoyer par mail un lien d'inscription à une personne, même si la course est
      complète.</p>
    <v-form ref="formCreateLienVIP" v-model="valid" class="mb-5">
      <v-row>
        <v-col md="4" cols="12">
          <label class="field_label">Indiquer l'adresse mail de la personne<span class="text-red">*</span></label>
          <v-text-field v-model="lien_VIP.mail" required ref="field_email" @blur="$refs.field_email.validate()"
            :rules="[$formRules.email(lien_VIP.mail)]"></v-text-field>
        </v-col>
        <v-col md="4" cols="12">
          <label class="field_label">Nombre de participants qui peuvent être inscrit avec ce code<span
              class="text-red">*</span></label>
          <v-text-field type="number" v-model="lien_VIP.nb_inscrits" required></v-text-field>
        </v-col>
        <v-col md="4" cols="12">
          <label class="field_label">Date d'expiration</label>
          <v-text-field type="date" v-model="lien_VIP.date_expiration"></v-text-field>
        </v-col>
      </v-row>

      <div class="text-h6 ">Les parcours</div>
      <v-row v-if="mainStore.module.courses.list.length > 0">

        <v-col md="4" cols="12">
          <label class="field_label">Le destinataire devra payer l'inscription aux parcours<span
              class="text-red">*</span></label>
          <v-select :items="items" v-model="lien_VIP.doit_payer_course"></v-select>
        </v-col>
        <v-col md="8" cols="12">
          <label class="field_label">Quels parcours doivent être disponible à l'inscription (même si complets) ?</label>
          <div></div>
          <div v-if="lien_VIP.limit_acces_parcours">Le
            choix de parcours sera limité à : {{ list_filtered_parcours }}</div>
          <div v-else>En ne limitant à aucun parcours, le
            participant pourra s'inscrire au parcours de son choix</div>

          <div>
            <div class="d-inline-flex justify-start flex-wrap">
              <v-checkbox class="mr-4" v-for="course in availables_parcours" v-model="course.selected" hide-details
                density="compact" :label="course.nom" :key="course.id"></v-checkbox>
            </div>
          </div>
        </v-col>
      </v-row>
      <div class="text-h6">Les options</div>
      <v-row>

        <v-col md="6" cols="12">
          <label class="field_label">Le destinataire devra payer l'inscription aux options<span
              class="text-red">*</span></label>
          <v-select :items="items" v-model="lien_VIP.doit_payer_option"></v-select>
        </v-col>
        <v-col md="6" cols="12">
          <label class="field_label">Le destinataire pourra s'inscrire aux options complètes<span
              class="text-red">*</span></label>
          <v-select :items="items" v-model="lien_VIP.acces_options_completes"></v-select>
        </v-col>
      </v-row>
      <div class="text-h6">Les activités</div>
      <v-row>

        <v-col md="6" cols="12">
          <label class="field_label">Le destinataire devra payer l'inscription aux activités<span
              class="text-red">*</span></label>
          <v-select :items="items" v-model="lien_VIP.doit_payer_activite"></v-select>
        </v-col>
        <v-col md="6" cols="12">
          <label class="field_label">Le destinataire pourra s'inscrire aux activités complètes<span
              class="text-red">*</span></label>
          <v-select :items="items" v-model="lien_VIP.acces_activites_completes"></v-select>
        </v-col>
      </v-row>

      <div class="d-flex justify-center mt-3">
        <v-btn color="primary-dark" @click="validate()">Envoyer le lien privilégié</v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import Lien_VIP from "@/classes/Lien_VIP/Lien_VIP.class";
export default {
  data() {
    return {
      lien_VIP: new Lien_VIP(),
      valid: false,
      items: [
        { title: "0ui", value: 1 },
        { title: "Non", value: 0 },
      ],
      availables_parcours: [],
      list_courses: {},
      list_packs_courses: {},
    };
  },
  watch: {
    "lien_VIP.filter_parcours": {
      handler: function (val) {
        this.lien_VIP.limit_acces_parcours = val.filter((course) => course.selected).length > 0;
      },
      deep: true,
    },
    availables_parcours: {
      handler: function (val) {
        this.lien_VIP.filter_parcours = val.filter((course) => course.selected);
      },
      deep: true,
    },
  },

  computed: {
    ...mapStores(useMainStore),
    list_filtered_parcours() {
      return this.lien_VIP.filter_parcours
        .filter((course) => course.selected)
        .map((course) => course.nom)
        .join(", ");
    },
  },
  methods: {
    build_available_parcours() {
      this.availables_parcours = this.mainStore.module.courses.list.map((course) => {
        return {
          id: course.id,
          nom: course.nom,
          selected: false,
        };
      });
    },
    async validate() {
      let response = await this.$refs.formCreateLienVIP.validate();
      if (response.valid) {

        this.lien_VIP.id_module = this.mainStore.module.id;
        await this.lien_VIP.post();
        this.$router.go();
      }
    },
  },
  async created() {
    this.build_available_parcours();
  },
};
</script>

<style lang="scss" scoped></style>